import { CrossFrameUtils } from '@src/utils';

/**
 *  The MetricTimer should be used when you need to track times across scopes or
 *  frames. Note: this may not be fully accurate because these timestamps are captured
 *  after a cross frame message. For simple uses to start a metric and then stopping it
 *  within the same scope, it is better to just create a LatencyMetrics object.
 */
export class MetricTimer {
    public startTimer(storeId, name, program, operation) {
        CrossFrameUtils.sendMessageToOtherFrame({
            frame: window,
            message: {
                method: 'StartMetricTimer',
                data: {
                    storeId,
                    name,
                    program,
                    operation,
                },
            },
        });
    }

    public stopTimer(name) {
        CrossFrameUtils.sendMessageToOtherFrame({
            frame: window,
            message: {
                method: 'StopMetricTimer',
                data: {
                    name,
                },
            },
        });
    }

    public resetTimer(name) {
        CrossFrameUtils.sendMessageToOtherFrame({
            frame: window,
            message: {
                method: 'ResetMetricTimer',
                data: {
                    name,
                },
            },
        });
    }
}
